import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-light" }
const _hoisted_2 = {
  class: "nav nav-tabs",
  id: "nav-tab",
  role: "tablist"
}
const _hoisted_3 = {
  class: "tab-content border p-4",
  id: "nav-tabContent"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "nav-dash",
  role: "tabpanel",
  "aria-labelledby": "nav-dash-tab"
}, " Gráficos sobre os emails enviados aqui ", -1)
const _hoisted_5 = {
  class: "tab-pane fade show active",
  id: "nav-funil",
  role: "tabpanel",
  "aria-labelledby": "nav-funil-tab"
}
const _hoisted_6 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_7 = {
  href: "javascript:void(0);",
  "data-bs-toggle": "modal",
  "data-bs-target": "#novobroadcast"
}
const _hoisted_8 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-header" }
const _hoisted_11 = { class: "float-start" }
const _hoisted_12 = { class: "float-end btn-group" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "card mb-0 h-100" }
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "dropdown float-end" }
const _hoisted_23 = {
  href: "#",
  class: "dropdown-toggle arrow-none card-drop",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_24 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Novo")
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Testar")
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Edit")
const _hoisted_31 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Detele")
const _hoisted_34 = { class: "header-title" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  class: "text-muted fw-normal mt-0 text-truncate",
  title: "Campaign Sent"
}
const _hoisted_37 = { class: "d-flex align-items-center mt-4" }
const _hoisted_38 = { class: "flex-shrink-0" }
const _hoisted_39 = { class: "font-13 text-muted my-0" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 ms-2" }, null, -1)
const _hoisted_42 = { class: "text-end" }
const _hoisted_43 = { class: "row g-1" }
const _hoisted_44 = {
  href: "javascript:void(0);",
  class: "d-inline-block text-dark text-decoration-none"
}
const _hoisted_45 = {
  href: "javascript:void(0);",
  class: "d-inline-block text-dark text-decoration-none"
}
const _hoisted_46 = {
  href: "javascript:void(0);",
  class: "d-inline-block text-dark text-decoration-none"
}
const _hoisted_47 = { class: "col-sm-1 col-xl-1 mb-2" }
const _hoisted_48 = { class: "card-body" }
const _hoisted_49 = { class: "border-dashed h-100 w-100 rounded d-flex align-items-center justify-content-center" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "font-16 mt-1 mb-0 d-block" }
const _hoisted_52 = { class: "col-sm-1 col-xl-1 mb-2" }
const _hoisted_53 = { class: "card-body" }
const _hoisted_54 = { class: "border-dashed h-100 w-100 rounded d-flex align-items-center justify-content-center" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "font-16 mt-1 mb-0 d-block" }
const _hoisted_57 = { class: "card-footer text-muted" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "nav-lead",
  role: "tabpanel",
  "aria-labelledby": "nav-lead-tab"
}, " Entra aqui os leads ", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "nav-config",
  role: "tabpanel",
  "aria-labelledby": "nav-config-tab"
}, " Destinado a configurações do robo, como quantidade de emails a serem enviados para um determinado período de tempo, edição do nome da lista e etc. ", -1)
const _hoisted_60 = {
  key: 0,
  class: "d-flex justify-content-center mt-4 mb-4"
}
const _hoisted_61 = {
  class: "modal fade",
  id: "novobroadcast",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_62 = {
  class: "modal fade",
  id: "editbroadcast",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_63 = {
  class: "modal fade",
  id: "novoemail",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_64 = {
  class: "modal fade",
  id: "editemail",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_65 = {
  class: "modal fade",
  id: "veragendaemail",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_66 = {
  class: "modal fade",
  id: "verbroadleads",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_NovoBroadcast = _resolveComponent("NovoBroadcast")!
  const _component_EditBroadcast = _resolveComponent("EditBroadcast")!
  const _component_NovoEmail = _resolveComponent("NovoEmail")!
  const _component_EditEmail = _resolveComponent("EditEmail")!
  const _component_VerAgendaEmail = _resolveComponent("VerAgendaEmail")!
  const _component_BroadLeads = _resolveComponent("BroadLeads")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "nav-link",
          id: "nav-form-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-dash",
          type: "button",
          role: "tab",
          "aria-controls": "nav-dash",
          "aria-selected": "false",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.changbreadmenu('Dasboard')))
        }, "Dasboard"),
        _createElementVNode("button", {
          class: "nav-link active",
          id: "nav-funil-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-funil",
          type: "button",
          role: "tab",
          "aria-controls": "nav-funil",
          "aria-selected": "true",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changbreadmenu('Campanha')))
        }, "Campanha"),
        _createElementVNode("button", {
          class: "nav-link",
          id: "nav-lead-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-lead",
          type: "button",
          role: "tab",
          "aria-controls": "nav-lead",
          "aria-selected": "false",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changbreadmenu('Leads')))
        }, "Leads"),
        _createElementVNode("button", {
          class: "nav-link",
          id: "nav-config-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-config",
          type: "button",
          role: "tab",
          "aria-controls": "nav-config",
          "aria-selected": "false",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changbreadmenu('Configurações')))
        }, "Configurações")
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", _hoisted_7, [
            _createVNode(_component_font_awesome_icon, { icon: "file" })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("input", {
            class: "form-control",
            placeholder: "Procurar Nome ou Descrição",
            onKeyup: _cache[4] || (_cache[4] = ($event: any) => ($setup.search($event.target.value)))
          }, null, 32)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredTable, (broadcast) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "pt-3 pb-2 mb-3",
            key: broadcast.id
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(broadcast.name), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    class: "btn btn-sm btn-outline-secondary",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#verbroadleads",
                    onClick: ($event: any) => ($setup.showleads(broadcast.id)),
                    title: "ver leads da campanha"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "users" })
                  ], 8, _hoisted_13),
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn btn-sm btn-outline-secondary",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#editbroadcast",
                    title: "Alterar Campanha",
                    onClick: ($event: any) => ($setup.Alterar(broadcast.id))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                  ], 8, _hoisted_14),
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn btn-sm btn-outline-secondary",
                    title: "Ativar Campanha",
                    onClick: ($event: any) => ($setup.ativar(broadcast.id))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "thumbs-up" })
                  ], 8, _hoisted_15),
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn btn-sm btn-outline-secondary",
                    title: "Inativar Campanha",
                    onClick: ($event: any) => ($setup.inativar(broadcast.id))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "thumbs-down" })
                  ], 8, _hoisted_16),
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn btn-sm btn-outline-secondary",
                    title: "Excluir Campanha",
                    onClick: ($event: any) => ($setup.del(broadcast.id))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "trash-alt" })
                  ], 8, _hoisted_17)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(broadcast.emails_order, (email) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-sm-3 col-xl-3 mb-3",
                      key: email.id
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("a", _hoisted_23, [
                              _createVNode(_component_font_awesome_icon, { icon: "envelope" })
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "dropdown-item",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#novoemail",
                                id: "btnnovoemail",
                                onClick: ($event: any) => ($setup.emailnovo(broadcast.id))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "plus-circle" }),
                                _hoisted_26
                              ], 8, _hoisted_25),
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "dropdown-item",
                                onClick: ($event: any) => ($setup.emailteste(email.id,email.title))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "envelope" }),
                                _hoisted_28
                              ], 8, _hoisted_27),
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "dropdown-item",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#editemail",
                                id: "btneditemail",
                                onClick: ($event: any) => ($setup.emailedit(broadcast.id,email.id))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" }),
                                _hoisted_30
                              ], 8, _hoisted_29),
                              _hoisted_31,
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "dropdown-item",
                                onClick: ($event: any) => ($setup.delEmail(email.id))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "trash-alt" }),
                                _hoisted_33
                              ], 8, _hoisted_32)
                            ])
                          ]),
                          _createElementVNode("h5", _hoisted_34, [
                            _createElementVNode("a", {
                              href: "javascript:void(0);",
                              class: "text-decoration-none",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#editemail",
                              id: "btneditemail",
                              onClick: ($event: any) => ($setup.emailedit(broadcast.id,email.id))
                            }, _toDisplayString(email.title), 9, _hoisted_35)
                          ]),
                          _createElementVNode("h6", _hoisted_36, _toDisplayString(email.subject), 1),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("h6", _hoisted_39, [
                                _createElementVNode("a", {
                                  href: "javascript:void(0)",
                                  class: "text-decoration-none",
                                  title: "Click para Habilitar/Desabilitar Email",
                                  onClick: ($event: any) => ($setup.ativarInativarEmail(email.enable,email.id))
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(email.enable===1 ? 'badge bg-primary ' : 'badge bg-danger ')
                                  }, _toDisplayString(email.enable===1 ? ' Ativo ' : 'Inativo'), 3)
                                ], 8, _hoisted_40)
                              ])
                            ]),
                            _hoisted_41,
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("a", _hoisted_44, [
                                  _createVNode(_component_font_awesome_icon, { icon: "at" }),
                                  _createTextVNode("   " + _toDisplayString(email.totalemailsents.length), 1)
                                ]),
                                _createElementVNode("a", _hoisted_45, [
                                  _createVNode(_component_font_awesome_icon, { icon: "mouse" }),
                                  _createTextVNode("   " + _toDisplayString(email.emailclicks.length), 1)
                                ]),
                                _createElementVNode("a", _hoisted_46, [
                                  _createVNode(_component_font_awesome_icon, { icon: "book-reader" }),
                                  _createTextVNode("   " + _toDisplayString(email.emailreads.length), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          class: "text-center text-muted p-2",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#novoemail",
                          id: "cardnovoemail",
                          onClick: ($event: any) => ($setup.emailnovo(broadcast.id)),
                          title: "Novo Email"
                        }, [
                          _createElementVNode("h1", _hoisted_51, [
                            _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
                          ])
                        ], 8, _hoisted_50)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          class: "text-center text-muted p-2",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#veragendaemail",
                          id: "btnveragendaemail",
                          onClick: ($event: any) => ($setup.veragendaemail(broadcast.id)),
                          title: "ver agenda dos emails"
                        }, [
                          _createElementVNode("h1", _hoisted_56, [
                            _createVNode(_component_font_awesome_icon, { icon: "clock" })
                          ])
                        ], 8, _hoisted_55)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("span", {
                  class: _normalizeClass(broadcast.enable===1 ? 'badge bg-primary ' : 'badge bg-danger ')
                }, _toDisplayString(broadcast.enable===1 ? ' Ativo ' : 'Inativo'), 3)
              ])
            ])
          ]))
        }), 128))
      ]),
      _hoisted_58,
      _hoisted_59
    ]),
    ($setup.page < $setup.lastPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-secondary",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.loadMore && $setup.loadMore(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_61, [
      _createVNode(_component_NovoBroadcast, {
        onSetClick: $setup.close,
        userid: `${$setup.dados.user_id}`
      }, null, 8, ["onSetClick", "userid"])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _createVNode(_component_EditBroadcast, {
        onSetClick: $setup.close,
        broad_id: `${$setup.choosegrupo}`,
        listgroups: $setup.listgroups
      }, null, 8, ["onSetClick", "broad_id", "listgroups"])
    ]),
    _createElementVNode("div", _hoisted_63, [
      _createVNode(_component_NovoEmail, {
        onSetClick: $setup.close,
        broad_id: `${$setup.choosegrupo}`,
        position: `${$setup.newposition}`
      }, null, 8, ["onSetClick", "broad_id", "position"])
    ]),
    _createElementVNode("div", _hoisted_64, [
      _createVNode(_component_EditEmail, {
        onSetClick: $setup.close,
        email: $setup.choosemail,
        groupmails: $setup.groupmails,
        urls: $setup.urls
      }, null, 8, ["onSetClick", "email", "groupmails", "urls"])
    ]),
    _createElementVNode("div", _hoisted_65, [
      _createVNode(_component_VerAgendaEmail, {
        onSetClick: $setup.close,
        broadid: `${$setup.choosegrupo}`,
        emails: $setup.emailsag
      }, null, 8, ["onSetClick", "broadid", "emails"])
    ]),
    _createElementVNode("div", _hoisted_66, [
      _createVNode(_component_BroadLeads, {
        onSetClick: $setup.close,
        broadlead: `${$setup.broadlead}`
      }, null, 8, ["onSetClick", "broadlead"])
    ])
  ]))
}